import React from 'react';
import {
  TableCell, Skeleton, Chip,
} from '@mui/material';
import { Typography } from 'bso-ui';
import API from 'common/api';
import useDetail from 'hooks/useDetail';

const RadioStatus = ({ circuit }) => {
  const query = {
    storeKey: `radio-circuit-${circuit}`,
    apiEndpoint: `${API.MONITORING_RESULTS}/${circuit}/`
  };

  const [{
    data, isError, isLoading
  }] = useDetail(query.storeKey, query.apiEndpoint, { refetchInterval: 60000 });

  const getStatus = (res) => {
    let status = -1;
    for (let i = 0; i < res?.length; i++) {
      const itemStatus = res[i].check?.status;
      if (status < itemStatus) status = itemStatus;
    }
    let label = '';
    let color = '';
    if (status === 0) {
      label = 'Ok';
      color = 'success';
    } else if (status === 1) {
      label = 'Check it and tell us';
      color = 'warning';
    } else if (status === 2) {
      label = 'Error(s)';
      color = 'error';
    } else {
      label = 'No device';
      color = 'info';
    }
    return (
      <Chip
        label={label}
        color={color}
        style={color === 'error' ? { animation: 'blinker 1s linear infinite' } : {}}
      />
    );
  };

  if (isError) {
    return (
      <TableCell><Typography>Error</Typography></TableCell>
    );
  }

  if (isLoading || !data) {
    return (
      <TableCell><Skeleton variant="text" /></TableCell>

    );
  }

  return (
    <TableCell>
      {getStatus(data || null)}
    </TableCell>
  );
};

export default RadioStatus;
